import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'i18nPipe',
})
export class i18nPipe implements PipeTransform {
    transform(value: string) {
       // debugger;
       let data = localStorage.getItem("datai18n");
       let datai18n = JSON.parse(data);
	   let valor = datai18n[value];
	   
       return valor;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/_utils/pipes/i18nPipe.ts